var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-office-docx',{staticClass:"docx-container",attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }